module.exports = __webpack_public_path__ + "mp3/llama-2.91-deed9f60e1c2a04e753d90c72d57bea1.mp3";